import * as React from 'react';
import { SVGProps } from 'react';

const IconRUOSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 5.365V1.999a.482.482 0 0 1-.48-.499c0-.276.202-.5.48-.5h3c.278 0 .5.224.5.5s-.222.5-.5.5v3.465l.51.664-4.492.675.982-1.44Zm-1.77 2.57 5.919-.891L10.364 9.5c.387.667-.098 1.5-.873 1.5H2.509c-.776 0-1.26-.833-.872-1.5l1.092-1.565ZM4.5 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1ZM7 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    />
  </svg>
);
export default IconRUOSizeXs;
